"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineAuthStore = void 0;

var _generalStore = _interopRequireDefault(require("general-store"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _ActionTypes = _interopRequireDefault(require("crm_data/actions/ActionTypes"));

var _always = _interopRequireDefault(require("transmute/always"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Raven = _interopRequireDefault(require("Raven"));

var _enviro = _interopRequireDefault(require("enviro"));

var defineAuthStore = function defineAuthStore(_ref) {
  var _ref$getter = _ref.getter,
      getter = _ref$getter === void 0 ? _identity.default : _ref$getter,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? [] : _ref$initialState,
      name = _ref.name,
      onAuthLoad = _ref.onAuthLoad;
  (0, _invariant.default)(typeof name === 'string' && name !== '', 'Name for auth store must be provided');
  (0, _invariant.default)(typeof onAuthLoad === 'function', 'onAuthLoad must be provided and be a function');
  var getInitialState = (0, _always.default)({
    isAuthLoaded: false,
    authData: initialState
  });
  return _generalStore.default.defineFactory().defineName("Auth-" + name).defineGetInitialState(getInitialState).defineGet(function (state) {
    var isAuthLoaded = state.isAuthLoaded,
        authData = state.authData;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!isAuthLoaded) {
      if (_enviro.default.isProd()) {
        _Raven.default.captureMessage('Attempted to access an Auth store without dispatching an AUTH_LOADED action', {
          extra: {
            args: args,
            name: name
          },
          level: 'info'
        });
      }

      _devLogger.default.warn({
        message: 'Attempted to access an Auth store without dispatching an AUTH_LOADED action'
      });
    }

    return getter.apply(void 0, [authData].concat(args));
  }).defineResponseTo(_ActionTypes.default.AUTH_LOADED, function (_, auth) {
    return {
      isAuthLoaded: true,
      authData: onAuthLoad(auth)
    };
  });
};

exports.defineAuthStore = defineAuthStore;